// Copyright (c) 2026 WiseTime. All rights reserved.

export const WELCOME_VIDEO_WINDOW_DAYS = 30
export const WELCOME_VIDEO_COOLDOWN_DAYS = 1

export type DialogStatus = "OPEN" | "CLOSED"

export type WelcomeVideoState = {
  lastShownAt?: number | null,
  dismissed?: boolean, // undefined = not loaded/old user, true = user clicked "don't show me again", false = active
  dialogStatus: DialogStatus,
}
